// extracted by mini-css-extract-plugin
export default {"container":"toolsIA_container__CDwB6","newQuizzesContainer":"toolsIA_newQuizzesContainer__f+fvD","textDraw":"toolsIA_textDraw__-xpGW"};